import internalTemplate from '@/templates/internal.json'
import externalTemplate from '@/templates/external.json'

export default [
  {
    path: '/static/internal',
    name: 'static-internal',
    component: () => import('@/views/Internal.vue'),
    props: () => ({
      email: internalTemplate,
    }),
  },
  {
    path: '/static/external',
    name: 'static-external',
    component: () => import('@/views/External.vue'),
    props: () => ({
      email: externalTemplate,
    }),
  },
]
